
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { BuildingResponse } from "../../models/dtos";

export const buildingsApi = createApi({
  reducerPath: 'buildingsApi',
  baseQuery: baseAuthQuery('Buildings'),
  tagTypes: ['Building'],
  endpoints: (builder) => ({
    getBuildings: builder.query<ApiResponse<BuildingResponse[]>, void>({
      query: () => "",
      providesTags: ['Building'],
    }),
    getBuildingById: builder.query<ApiResponse<BuildingResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['Building'],
    }),
    updateBuilding: builder.mutation<ApiResponse<BuildingResponse>, Partial<BuildingResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['Building'],
    }),
    deleteBuilding: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['Building'],
    }),
  }),
});
